<template>
    <div class="sm:flex sm:justify-between sm:items-center">
        <div class="mb-2 sm:mb-0">
            <div class="grid grid-cols-1 sm:hidden">
                <select aria-label="Select a tab" v-model="selectedDropdownOption"
                        class="font-base col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600">
                    <option v-for="tab in tabs" :key="tab.name" :value="tab" :selected="tab.current">{{ tab.name }}</option>
                </select>
            </div>
            <div class="hidden sm:block">
                <div class="border-b border-gray-200">
                    <nav class="-mb-px flex gap-x-8" aria-label="Tabs">
                        <a v-for="tab in tabs" :key="tab.name" href="#"
                           @click="handleClick(tab.name)"
                           :class="[tab.current ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700',
                           'flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium', tab.name === 'Details' ? 'lg:hidden' : '']"
                           :aria-current="tab.current ? 'page' : undefined">
                            {{ tab.name }}
                            <span v-if="tab.count"
                                  :class="[tab.current ? 'bg-indigo-100 text-indigo-600' : 'bg-gray-300 text-gray-900',
                                  'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block']">{{ tab.count }}</span>
                        </a>
                    </nav>
                </div>
            </div>
        </div>
        <slot name="floatRight"></slot>
    </div>
</template>

<script>
export default {
    name: "tabs",
    props: ["tabs", "selectedTab"],
    data () {
        return {
            selectedDropdownOption: this.tabs.find(tab => tab.name.toLowerCase() === this.selectedTab?.toLowerCase()) || this.tabs[0],
        };
    },
    watch: {
        selectedDropdownOption (newVal) {
            this.handleClick(newVal.name);
        },
    },
    methods: {
        handleClick (targetTabName) {
            this.$emit("change-tab", targetTabName.toLowerCase());
        }
    }
};
</script>

